import {Component, Input} from '@angular/core';
import {ContactService} from '../../service/contact.service';
import {ActivatedRoute} from '@angular/router';
import {EnquireNowFormStateMatcher} from './enquire-now-form.state-matcher';
import {ProfileType} from '../../model/profile-type.model';

@Component({
    selector: 'app-enquire-now-form',
    templateUrl: './enquire-now-form.component.html',
    styleUrls: ['./enquire-now-form.component.css']
})
export class EnquireNowFormComponent {
    @Input()
    profileType: ProfileType;
    name: string;
    email: string;
    phoneNumber: string;
    convenientTime = '10am - 8pm';
    submissionMessage: string;
    submissionResult: boolean;
    enquireNowMatcher = new EnquireNowFormStateMatcher();
    isCaptchaResolved = false;

    constructor(private contactService: ContactService, private activatedRoute: ActivatedRoute) {
    }

    async onSubmit(): Promise<void> {
        if (!this.formValid()) {
            return;
        }
        const queryParams = this.activatedRoute.snapshot.queryParams;
        let metadata = (queryParams) ? {...queryParams} : {};
        metadata = this.attachParams(metadata);

        try {
            await this.contactService.save({
                name: this.name,
                email: this.email,
                phoneNumber: this.phoneNumber,
                message: 'I have a query. Please get in touch with me.'
            }, metadata);
            this.submissionMessage = 'Thanks for providing your information, we will get back to you soon';
            this.submissionResult = true;
            this.clearAllInputFields();
        } catch (error) {
            this.submissionMessage = 'Something went wrong, please try again later';
            this.submissionResult = false;
        }
    }

    protected attachParams(metadata: { [p: string]: any } | {}): { [p: string]: any } | {} {
        (metadata as any).convenientTime = this.convenientTime;
        (metadata as any).profileType = this.profileType;
        return metadata;
    }

    protected clearAllInputFields(): void {
        this.name = '';
        this.email = '';
        this.phoneNumber = '';
        this.convenientTime = '';
        this.isCaptchaResolved = false;
    }

    private formValid(): boolean {
        return this.isCaptchaResolved;
    }
    captchaResolved(response: string) {
        this.isCaptchaResolved = response ? true : false;
    }
    captchaError(error: any) {
        this.isCaptchaResolved = false;
    }
}
